module.exports = __webpack_public_path__ + "media/images/select/select-dark-479c028c5f0613e0cbb33430608e79b0.svg";